export function waitForAllResources(resources) {
  return {
    onComplete(onLoad, onError) {
      const cleanups = [];
      const values = new Array(resources.length);
      let completed = false;
      const dispose = () => {
        cleanups.forEach(cleanup => cleanup());
        cleanups.length = 0;
      };
      const done = () => {
        dispose();
        completed = true;
      };
      let loadedResources = 0;
      for (let i = 0; i < resources.length && !completed; i++) {
        const completable = resources[i];
        cleanups.push(completable.onComplete(value => {
          values[i] = value;
          loadedResources++;
          if (loadedResources === resources.length) {
            onLoad(values);
            done();
          }
        }, error => {
          onError === null || onError === void 0 ? void 0 : onError(error);
          done();
        }));
      }
      return dispose;
    }
  };
}